import React, { useState ,useEffect} from "react";
import { makeStyles } from "@material-ui/core/styles";

import Grid from "@material-ui/core/Grid";

import UserTable from "./UserTable";
import { Button, Paper, TextField } from "@material-ui/core";
import Spacer from "../../../components/Spacer";
import MainContainer from "../../../components/MainContainer";
import { headerDataAdmin } from "../../../data/modules/admin-header";
import { userDetailContext } from "../../../App";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import SearchIcon from '@mui/icons-material/Search';
import RestartAltIcon from '@mui/icons-material/RestartAlt';



const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(1),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 0,
  },
}));

export default function UserLists() {
  const navigate = useNavigate();
  const classes = useStyles();
  const contextData = useContext(userDetailContext);
  const [name, setName] = useState("");
  const [filters,setFilters]=useState({name:""});
 
   const handleSubmit = () => {
      setFilters({
        name:name
      });
   };

    function handleChange1(ev) {
      const { name, value } = ev.target;
      setName(value);
    }

    function handlereinitiale()
    {
      setName("");
       setFilters({
        name:""
      });
    }


  return (
    <MainContainer {...headerDataAdmin}>
      <Spacer y={4}/>
      <Grid container spacing={3}>
            <Button
                variant="contained"
                color="secondary"
                onClick={handlereinitiale} 
                style={{ fontWeight: 800 ,width:170}}
            >
                <RestartAltIcon style={{ marginRight: '8px' }} />
                     réinitialiser
            </Button>
            <Spacer x={6} />
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              startIcon={<SearchIcon />}
              style={{ fontWeight: 800 ,width:170}}
           >
             Filtrer
          </Button>
          <Spacer x={6} />
           <TextField
                style={{width:"400px"}}
                id="outlined-basic"
                size="small"
                label="Nom et prénom(s)"
                variant="outlined"
                onChange={handleChange1}
                value={name}
                name="name"
           />
      </Grid>
      <Spacer y={8}/>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper className={classes.paper} variant="outlined">
            <UserTable name={filters.name} />
          </Paper>
        </Grid>
      </Grid>
    </MainContainer>
  );
}
